import React, {useCallback, useMemo} from 'react';
import {useDispatch, useSelector} from 'react-redux';


import {clearSelection} from 'src/components/data-table-selection';
import {SortDirection as SortDirections} from 'src/openapi/admin/models/SortDirection';

import {SortHeaderWithDataTable} from '@pb/kit-component-sort-header';

import {HEADERS, SELECTION_KEY} from '../../constants';
import {accountSearchResultStateActions, accountSearchResultStateSelector} from '../../slices/account-search-result-state.slice';
import {mapColumnIdToAccountSortField} from '../../utils';

import type {SortDirection} from 'src/openapi/admin/models/SortDirection';

type Props = {
    columnId: string,
};

export const SortableHeader = ({columnId}: Props) => {
    const dispatch = useDispatch();
    const cacheKeys = useSelector(accountSearchResultStateSelector);

    const sortField = useMemo(() => mapColumnIdToAccountSortField(columnId), [columnId]);

    const sort = useCallback((direction: ('ASC' | 'DESC')) => {
        dispatch(clearSelection(SELECTION_KEY));
        dispatch(
            accountSearchResultStateActions.setSortCriteria({
                direction: direction as SortDirection,
                field: sortField,
            }),
        );
    }, [sortField, dispatch]);

    return (
        <SortHeaderWithDataTable
            defaultDirection={SortDirections.ASC}
            direction={cacheKeys.sortCriteria.field === sortField ? cacheKeys.sortCriteria.direction : null}
            filterActive={true}
            caption={HEADERS[columnId]}
            onSort={sort}
        />
    );
};
